<template>
<div class="chapter">
<div class="inner_page">
<div class="figure"><a id="page_xxvi"><img alt="Image" src="images/pgxxvi_1.jpg"/></a></div><a id="page_xxvi">
<p class="figcaption"><b>The Altai Region.</b> The mountainous Altai region lies at the center of the map and comprises territory belonging to Russia, China, Mongolia, and Kazakhstan.</p>
</a><div class="figure"><a id="page_xxvi"></a><a id="page_xxvii"><img alt="Image" src="images/pgxxvii_1.jpg"/></a></div><a id="page_xxvii">
<p class="figcaption"><b>Tuva.</b> The Republic of Tuva (Tyva) shares borders with Mongolia as well as five administrative units of the Russian Federation: Altai Republic, Republic of Xakasia (Khakasia), Krasnoyarsk Krai, Irkutsk Oblast, and the Republic of Buryatia.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_FM03.vue?2d419de6